import { render, staticRenderFns } from "./SliderWrapper.vue?vue&type=template&id=38e68ce3&scoped=true"
import script from "./SliderWrapper.vue?vue&type=script&lang=js"
export * from "./SliderWrapper.vue?vue&type=script&lang=js"
import style0 from "./SliderWrapper.vue?vue&type=style&index=0&id=38e68ce3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e68ce3",
  null
  
)

export default component.exports